function MeSHDiseaseClass() {
  return (
    <div>
      <li className="bullet-item">
        The{' '}
        <a
          className="tt"
          target="_blank"
          rel="noreferrer"
          href="http://www.nlm.nih.gov/research/umls/META3_current_semantic_types.html"
        >
          UMLS<sup>®</sup> semantic types{' '}
        </a>
        the{' '}
        <a className="tt" target="_blank" rel="noreferrer" href="https://meshb.nlm.nih.gov/treeView">
          MeSH
        </a>{' '}
        class: we classify the diseases according the MeSH hierarchy using the upper level concepts of the
        MeSH tree branch C (Diseases) plus three concepts of the F branch (Psychiatry and Psychology:
        "Behavior and Behavior Mechanisms", "Psychological Phenomena and Processes", and "Mental Disorders")
      </li>
    </div>
  );
}

export default MeSHDiseaseClass;
